module.exports = __webpack_public_path__ + "static/media/icon-activiti.cda45f43.svg";